<template>
  <success :show-promotes='isShowHd'>
  <thanks :email='email' :title="$t('billing.trial.upgrade_paid_success')">
     <subtitle v-if='showSubtitle' grey-background :sub-title="$t('billing.trial.upgrade_paid_success_desc', [this.trialPaymentInfo.planStartTime, this.trialPaymentInfo.totalAmount, this.trialPaymentInfo.planExpireTime])" />
     <get-started v-if='isShowHd' />
     <view-account v-else />
   </thanks>
 </success>
</template>
<script>
import Thanks from '@/views/succezz/thanks-template/index.vue';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import Success from '@/views/succezz/facade.vue';
import common from '@/views/succezz/mixin/common';
import { mapGetters } from 'vuex';
import GetStarted from '@/views/succezz/thanks-template/get-started.vue';

export default {
  props: {
    isShowHd: {
      type: Boolean,
      default: false,
    },
    isShowSubtitle: {
      type: Boolean,
      default: false, // default false, only scheduler & pro ft upgrade need to display it
    }
  },
  mixins: [common],
  components: { GetStarted, Success, Subtitle, ViewAccount, Thanks },
  computed: {
    ...mapGetters(['successConfig']),
    trialPaymentInfo() {
      return this.successConfig?.trialPaymentInfo ?? {};
    },
    showSubtitle() {
      return !!(this.trialPaymentInfo.planStartTime && this.trialPaymentInfo.totalAmount && this.trialPaymentInfo.planExpireTime) && !!this.isShowSubtitle;
    }
  }
};
</script>
